module.exports = {
  UPDATE: 'ott/index/config/update'
};
